import React, { CSSProperties } from 'react'

// Styles
import './styles.scss'

// Icons
import IconNext from './images/iconNext'

export default ({
  style,
  title,
  onClick,
  disabled,
}: {
  style?: CSSProperties
  title: string
  onClick: () => void
  disabled: boolean
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={'button-module-next'}
    >
      <span>{title}</span>
      <IconNext />
    </button>
  )
}
